import styles from "#batteries-included-components/Banners/ImportDataActionStatus/ImportDataActionStatus.module.scss";
import { useClearCalculationCache } from "#hooks/adapters/useEstimationMethods";
import { useGetOneJob } from "#hooks/adapters/useJobs";
import { useBulkActionToast } from "#src/components/hooks/useBulkActionToast";
import { useStickyState } from "#src/hooks/useStickyState";
import { Banner } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import { useTimeoutHandler } from "./Banners.helpers";

const cx = classNames.bind(styles);

export const CalculationsProgressBanner = ({
  jobStorageKey,
}: {
  jobStorageKey: string;
}) => {
  const { invalidate } = useClearCalculationCache();
  const [jobId, setJobId] = useStickyState<string>("", jobStorageKey);
  const job = useGetOneJob(jobId).data?.data;

  const resetJob = () => {
    invalidate();
    setJobId("");
  };

  useTimeoutHandler(job, "Failed to run calculations due to timeout", resetJob);

  useBulkActionToast({ job, resetJob, actionLabel: "Run calculations" });

  return jobId ? (
    <Banner
      className={cx("banner")}
      titleText="Calculation Running"
      actionContent={
        <>{job?.total_items ? `${job.total_items} row(s) calculating` : ""}</>
      }
      color="loading"
      variant="loading"
    />
  ) : null;
};
